module.exports = __webpack_public_path__ + "static/media/applePayBanner.fdaa540c.svg";